module.exports = __webpack_public_path__ + "img/ico_sdsl.bf133f2e.png";